<div *ngIf="(isSuperAdmin || isAdmin) && safeUrlIFrame" class="mb-3">
  <div class="d-flex mb-3" style="gap: 1rem">
    <input type="file" class="form-control" (change)="onFileSelected($event)" #fileInput />
    <button
      type="button"
      class="btn btn-secondary"
      (click)="clearSelectFile()"
      [disabled]="!newFile"
    >
      Clear
    </button>
  </div>
  <iframe [src]="safeUrlIFrame" frameborder="0" style="display: block; width: 100%; height: 500px">
  </iframe>
</div>
